module.exports = __webpack_public_path__ + "img/reset_camera_step_3.3eaa1a17.gif";